module.exports = __webpack_public_path__ + "img/4gen-logistics-mobile.eacfb94c.png";